import { Link } from "react-router-dom";

const ContactForm = ({ formData, handleSubmit, handleInputChange }) => {
  return (
    <form
      id="contactForm"
      onSubmit={handleSubmit}
      data-toggle="validator"
      data-focus="false"
    >
      <div className="form-group">
        <input
          type="text"
          className="form-control-input"
          id="name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <label className="label-control" htmlFor="name">
          Name
        </label>
        <div className="help-block with-errors"></div>
      </div>
      <div className="form-group">
        <input
          type="email"
          className="form-control-input"
          id="email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        <label className="label-control" htmlFor="email">
          Email
        </label>
        <div className="help-block with-errors"></div>
      </div>
      <div className="form-group">
        <input
          type="text"
          className="form-control-input"
          id="subject"
          value={formData.subject}
          onChange={handleInputChange}
          required
        />
        <label className="label-control" htmlFor="subject">
          Subject
        </label>
        <div className="help-block with-errors"></div>
      </div>
      <div className="form-group">
        <textarea
          className="form-control-textarea"
          id="message"
          value={formData.message}
          onChange={handleInputChange}
          required
        />
        <label className="label-control" htmlFor="message">
          Your message
        </label>
        <div className="help-block with-errors"></div>
      </div>
      <div className="form-group checkbox">
        <input
          type="checkbox"
          id="terms"
          checked={formData.terms}
          onChange={handleInputChange}
          value="Agreed-to-Terms"
          required
        />
        I have read and agree to Corso's stated
        <Link to="privacy-policy" style={{ margin: "0 2px" }}>
          Privacy Policy
        </Link>{" "}
        and
        <Link to="terms-conditions" style={{ margin: "0 2px" }}>
          Terms Conditions
        </Link>
        <div className="help-block with-errors"></div>
      </div>
      <div className="form-group">
        <button type="submit" className="form-control-submit-button">
          SUBMIT
        </button>
      </div>
      <div className="form-message">
        <div id="msgSubmit" className="h3 text-center hidden"></div>
      </div>
    </form>
  );
};

export default ContactForm;
